/**
 * @copyright 2015, Andrey Popp <8mayday@gmail.com>
 */

'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

require('font-awesome/css/font-awesome.css');

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _IconStack = require('./IconStack');

var _IconStack2 = _interopRequireDefault(_IconStack);

exports['default'] = _Icon2['default'];
exports.Icon = _Icon2['default'];
exports.IconStack = _IconStack2['default'];



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-fa/lib/index.js
 ** module id = 60
 ** module chunks = 0
 **/